import { render, staticRenderFns } from "./IrrRootComponent.vue?vue&type=template&id=107e0520"
import script from "./IrrRootComponent.vue?vue&type=script&lang=js"
export * from "./IrrRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports